import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { roleSelection, signIn } from '../../store/Login/actions';
import { IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Link, useNavigate } from 'react-router-dom';
import ForgotPassword from './forgotPassword';
import { Modal } from 'react-bootstrap';
import { SET_AUTH_DATA } from '../../store/Login/types';

const Login = ({ handleLoginClose, showLoginModal }) => {
  const dispatch = useDispatch();

  const rememberedUserData = JSON.parse(localStorage.getItem('rememberedUserData'));
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

  const handleForgotPassword = () => {
    setShowForgotPasswordModal(true);
    // handleLoginClose();
  }
  const handleCloseForgotPassword = () => {
    setShowForgotPasswordModal(false);
  }
  const [state, setState] = useState({
    userName: rememberedUserData?.userName || '',
    password: rememberedUserData?.password || '',
  });

  useEffect(() => {
    localStorage.setItem('rememberedUserData', JSON.stringify(state));
  }, [state]);
  const navigate = useNavigate()
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      signIn(state, navigate)(dispatch);
    }
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleLoginAuth = () => {
    signIn(state, navigate)(dispatch)
  }

  return (
    <>
      {showForgotPasswordModal ? <ForgotPassword
        isOpen={showForgotPasswordModal}
        closeForgotPassword={handleCloseForgotPassword}
        handleLoginClose={handleLoginClose}
      /> :
        <Modal show={showLoginModal} onHide={handleLoginClose} centered>
          {/* <div className='signup-popuo-header'>
            <div className='signup-popuo-title'>Login</div>
            <div><i className='fa fa-times' onClick={handleLoginClose}></i></div>
          </div> */}
          <Modal.Header closeButton>
            <Modal.Title>Login</Modal.Title>
          </Modal.Header>
          <div className='signup-popup-body'>
            <form className='signup-form'>
              <div className='row'>
                <div className=' col-md-12'>
                  <div><input type='text' className='form-control custom-input' placeholder='Username*' onChange={(e) => setState(pre => ({ ...pre, userName: e.target.value }))} /></div>
                  <div className='mt-4 position-relative'>
                    <input type={showPassword ? 'text' : 'password'} className='form-control custom-input' placeholder='Password*' onChange={(e) => setState(pre => ({ ...pre, password: e.target.value }))} onKeyDown={handleKeyDown} />
                    <IconButton style={{ position: 'absolute', top: '10px', right: '10px' }}
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </div>
                </div>
              </div>
                <div className='forgot-pwd-text mt-2' onClick={handleForgotPassword}>Forgot Password ?</div>
              <hr className=' horizontal-line' />
              <div className='text-center mt-2 fw-bold'><Button disabled={!Boolean(state.password && state.userName)} onClick={() => handleLoginAuth()} className='btn btn-lg btn-signup py-2 px-4'>Login</Button></div>
            </form>
            <div className='fw-medium mt-1 existing_user justify-content-center' style={{color:'#3f3f3f'}} >
                 For any assistance, please write to us at <div className='popup-ftr-text-link' color='#FF7D00'>&nbsp;info@gna.energy</div>
              </div>
          </div>
        </Modal>}
    </>
  );
}

export default Login;
